import React from "react";
import type { WabaTemplateComponent } from "@whatslly/types/waba/WhatsappBusinessApiTemplate";
import styles from "./EditTemplateModal.module.scss";

export const getTemplatePreviewData = (components: WabaTemplateComponent[] | undefined) => {
  if (!components) return { headerText: "", bodyText: "", footerText: "", buttons: [] as string[] };
  const header = components.find((c) => c.type === "HEADER");
  const body = components.find((c) => c.type === "BODY");
  const footer = components.find((c) => c.type === "FOOTER");
  const buttonsComp = components.find((c) => c.type === "BUTTONS");
  return {
    headerText: header?.type === "HEADER" && header.format === "TEXT" ? (header.text ?? "") : "",
    bodyText: body?.type === "BODY" ? body.text : "",
    footerText: footer?.type === "FOOTER" ? footer.text : "",
    buttons: buttonsComp?.type === "BUTTONS" ? buttonsComp.buttons.map((b) => b.text) : [],
  };
};

type TemplatePhonePreviewProps = {
  components: WabaTemplateComponent[] | undefined;
};

export const TemplatePhonePreview: React.FC<TemplatePhonePreviewProps> = ({ components }) => {
  const preview = getTemplatePreviewData(components);

  return (
    <div className={styles.phoneFrame}>
      <div className={styles.phoneHeader}>
        <div className={styles.phoneAvatar}>W</div>
        <span>WhatsApp</span>
      </div>
      <div className={styles.chatArea}>
        <div className={styles.chatBubble}>
          <div className={styles.bubbleContent}>
            {preview.headerText && <div className={styles.bubbleHeader}>{preview.headerText}</div>}
            {preview.bodyText && <div className={styles.bubbleBody}>{preview.bodyText}</div>}
            {preview.footerText && <div className={styles.bubbleFooter}>{preview.footerText}</div>}
            <div className={styles.bubbleTime}>12:00</div>
          </div>
        </div>
        {preview.buttons.length > 0 && (
          <div className={styles.previewButtons}>
            {preview.buttons.map((btn, i) => (
              <div key={i} className={styles.previewButton}>
                {btn}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
